// ============================================
// ROLC OneROLC - Formatters
// Version: 3.6.0
// ============================================

// ============================================
// Timestamp Formatter
// ============================================
export function formatTimestamp(ts) {
    if (!ts) return "";
    try {
        const d = new Date(ts);
        return d.toLocaleString();
    } catch (e) {
        return String(ts);
    }
}

// ============================================
// Capitalize Words
// ============================================
export function capitalizeWords(str) {
    if (!str) return "";
    return String(str).replace(/\b\w/g, c => c.toUpperCase());
}

// ============================================
// Date Formatter (YYYY-MM-DD for HTML inputs)
// ============================================
export function formatDateForInput(val) {
    if (!val) return "";
    const d = new Date(val);
    if (isNaN(d.getTime())) return String(val).trim();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

// ============================================
// Time Formatter (HH:MM for HTML inputs)
// ============================================
export function formatTimeForInput(val) {
    if (!val) return "";
    if (val instanceof Date) {
        const h = val.getHours();
        const m = val.getMinutes();
        if (isNaN(h) || isNaN(m)) return "";
        return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    }
    const str = String(val).trim();
    if (/^\d{2}:\d{2}$/.test(str)) return str;
    const parts = str.match(/^(\d{1,2}):(\d{2})$/);
    if (!parts) return str;
    const h = parseInt(parts[1], 10);
    const m = parseInt(parts[2], 10);
    if (isNaN(h) || isNaN(m)) return str;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

// ============================================
// Date Key Formatter (YYYY-MM-DD for grouping)
// ============================================
export function formatDateKey(date) {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();
    return year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
}


